import { Flex, Text } from "../../components";
import { useApp } from "../../hooks";

const TimeBanner = () => {
  const { timeBannerMessage } = useApp();

  if (!timeBannerMessage) return null;
  return (
    <Flex
      id="app-time-banner"
      align="center"
      justify="center"
      className="min-h-[3.5rem] bg-accent px-[1.6rem] py-[0.6rem] transition-all duration-300"
    >
      <Text children={timeBannerMessage} />
    </Flex>
  );
};

export default TimeBanner;
